import { code } from "@spscommerce/utils";

export const SpsButtonExamples = {
    button: {
        label: "Buttons",
        examples: {
            basic: {
                description: code`<p>Style variants</p>`,
                template: code`
                    <sps-button id="defaultButton" class="mr-1 mb-1" aria-label="Example of a default button">Default</sps-button>
                    <sps-button kind="confirm" class="mr-1 mb-1" aria-label="Example of a confirm button">Confirm</sps-button>
                    <sps-button kind="delete" class="mr-1 mb-1" aria-label="Example of a delete button">Delete</sps-button>
                    <sps-button kind="key" class="mr-1 mb-1" aria-label="Example of a key button">Key</sps-button>
                    <sps-button kind="link" class="mr-1 mb-1" aria-label="Example of a link button">Link</sps-button>
                `
            },
            spinning: {
                description: code`<p>Spinning</p>`,
                template: code`
                    <sps-button id="spinningButton" [spinning]="true" class="mr-1 mb-1" aria-label="Default">Default</sps-button>
                    <sps-button kind="confirm" [spinning]="true" class="mr-1 mb-1" aria-label="Confirm">Confirm</sps-button>
                    <sps-button kind="delete" [spinning]="true" class="mr-1 mb-1" aria-label="Delete">Delete</sps-button>
                    <sps-button kind="key" [spinning]="true" class="mr-1 mb-1" aria-label="Key">Key</sps-button>
                    <sps-button kind="link" [spinning]="true" class="mr-1 mb-1" aria-label="Link">Link</sps-button>
                `
            },
            iconButtons: {
                description: code`<p>Icons as button</p>`,
                template: code`
                    <sps-button id="iconButton" kind="icon" aria-label="Repair" icon="wrench" class="mr-1 mb-1"></sps-button>
                    <sps-button kind="icon" aria-label="Send" icon="paper-plane" class="mr-1 mb-1"></sps-button>
                    <sps-button kind="icon" aria-label="Delete" icon="trash" class="mr-1 mb-1"></sps-button>
                    <sps-button kind="icon" aria-label="Authorize" icon="key" class="mr-1 mb-1"></sps-button>
                    <sps-button kind="icon" aria-label="Download" icon="download-cloud" class="mr-1 mb-1"></sps-button>
                `
            },
            buttonsWithIcon: {
                description: code`<p>Buttons with icon</p>`,
                template: code`
                    <sps-button id="withIconButton" icon="drill" class="mr-1 mb-1">Default</sps-button>
                    <sps-button kind="confirm" icon="paper-plane" class="mr-1 mb-1">Confirm</sps-button>
                    <sps-button kind="delete" icon="trash" class="mr-1 mb-1">Delete</sps-button>
                    <sps-button kind="key" icon="key" class="mr-1 mb-1">Key</sps-button>
                    <sps-button kind="link" icon="download-cloud" class="mr-1 mb-1">Link</sps-button>
                `
            },
            submit: {
                description: code`<p>Submit Button</p>`,
                template: code`
                    <form (submit)="alertOnSubmit()">
                      <sps-button type="submit" kind="confirm" id="submitButton">Submit</sps-button>
                    </form>
                `,
                class: code`
                    class DemoComponent {
                        alertOnSubmit() {
                            window.alert("Form submitted");
                        }
                    }
                `
            },
            disabled: {
                description: code`<p>Disabled</p>`,
                template: code`
                    <sps-button (click)="alert()" disabled class="mr-1" id="disabled">Submit</sps-button>
                    <sps-button kind="link" (click)="alert()" disabled class="mr-1">
                      Submit
                    </sps-button>
                `,
                class: code`
                    class DemoComponent {
                        alert() {
                            window.alert("That button is disabled, so this should not have fired! Whoops!");
                        }
                    }
                `
            },
            link: {
                description: code`
                    <h5>Button as a link</h5>
                    <p>(Not necessarily styled as a link, e.g. kind="link")</p>
                `,
                template: code`
                    <sps-button kind="key" routerLink="/components/angular/containers-&-content/card" id="linkButton" class="mr-1">
                      Cards
                    </sps-button>
                    <sps-button href="https://google.com">Google</sps-button>
                `
            }
        }
    },
    group: {
        label: "Button Groups",
        description: code`
                <p>This kind of grouping of buttons is used in the headers and
                footers of cards, list toolbars, and list action bars.</p>
            `,
        examples: [
            {
                template: code`
                    <sps-card>
                        <sps-card-header>
                            <sps-button-group>
                            <sps-button kind="link">Link Button A</sps-button>
                            <sps-button kind="link">Link Button B</sps-button>
                            </sps-button-group>
                        </sps-card-header>
                    </sps-card>
                `
            },
            {
                template: code`
                    <sps-card>
                        <sps-card-header>
                            <sps-button-group>
                            <sps-button kind="icon" aria-label="Download" icon="download-cloud"></sps-button>
                            <sps-button kind="icon" aria-label="Print" icon="printer"></sps-button>
                            </sps-button-group>
                        </sps-card-header>
                    </sps-card>
                `
            },
            {
                template: code`
                    <sps-card>
                        <sps-card-header>
                            <sps-button-group>
                            <sps-button>Button</sps-button>
                            <sps-button kind="key">Key Button</sps-button>
                            </sps-button-group>
                        </sps-card-header>
                    </sps-card>
                `
            },
            {
                template: code`
                    <sps-card>
                        <sps-card-header>
                            <sps-button-group>
                            <sps-button kind="link">Link Button</sps-button>
                            <sps-button>Button</sps-button>
                            <sps-button kind="key">Key Button</sps-button>
                            </sps-button-group>
                        </sps-card-header>
                    </sps-card>
                `
            },
            {
                template: code`
                    <sps-card>
                        <sps-card-header>
                            <sps-button-group>
                            <sps-button kind="link">Link Button</sps-button>
                            <sps-button kind="icon" aria-label="Download" icon="download-cloud"></sps-button>
                            <sps-button kind="icon" aria-label="Print" icon="printer"></sps-button>
                            </sps-button-group>
                        </sps-card-header>
                    </sps-card>
                `
            },
            {
                template: code`
                    <sps-card>
                        <sps-card-header>
                            <sps-button-group>
                            <sps-button kind="icon" aria-label="Download" icon="download-cloud"></sps-button>
                            <sps-button kind="icon" aria-label="Print" icon="printer"></sps-button>
                            <sps-button>Button</sps-button>
                            </sps-button-group>
                        </sps-card-header>
                    </sps-card>
                `
            },
            {
                template: code`
                    <sps-card>
                        <sps-card-header>
                            <sps-button-group>
                            <sps-button kind="link">Link Button</sps-button>
                            <sps-button kind="icon" aria-label="Download" icon="download-cloud"></sps-button>
                            <sps-button kind="icon" aria-label="Print" icon="printer"></sps-button>
                            <sps-button>Button</sps-button>
                            </sps-button-group>
                        </sps-card-header>
                    </sps-card>
                `
            }
        ]
    }
};
